import { EyeClosedIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const EyeSlash = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <EyeClosedIcon size={Sizes[size]} color={fill} {...rest} />;
};

EyeSlash.displayName = 'EyeSlash';
